import React, { useState, useEffect, useCallback } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { TbPointFilled } from "react-icons/tb";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdNotificationsActive } from "react-icons/md";
import axios from "axios";
import { useSelector } from "react-redux";
import EmptyNotif from "./EmptyNotif";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotifPage() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [notif, setNotif] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNotifsLoading, setIsNotifsLoading] = useState(true);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const location = useLocation();
  const { userId } = location?.state;
  const [member, setMember] = useState(null);

  const [user, setUser] = useState(null);
  const [canFetch, setCanFetch] = useState(false);
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const [membership, setMembership] = useState(null);

  // Replace with the actual user ID or parameter


  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      setIsLoading(true);
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);
        if (response.data?.membership?.status === "valid") {
          setMember(response.data.membership);
          // setPack(response.data.membership?.membership_packs);
          
        }
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setIsLoading(false);
      setCanFetch(true);
    }
  }, [baseUrl]);

  const fetchNotification = useCallback(
    async (id) => {
      try {
        setIsNotifsLoading(true);
        const response = await axios.get(`${baseUrl}/notifications`, {
          params: {
            id: id || user?.id,
          },
        });
        setNotif(response.data.notifications);
        
      } catch (error) {
      // setError(err.response?.data.message);
      } finally {
        setIsNotifsLoading(false);
      }
    },
    [baseUrl]
  );

  useEffect(() => {
    fetchUser();

    if (canFetch) {
      
      if (user) {
        fetchNotification(user?.id);
      }
    }
  }, [canFetch]);

  

  const getimages = (packType) => {
    if (packType) {
      return membership?.membership_packs?.logo;
    }

    return images.visiteur_logo;
  };
  const imagess = getimages(membership?.membership_packs?.logo);

  if (!notif || (notif?.length === 0 && !isLoading)) {
    return <EmptyNotif />;
  } else {
    const displayedNotifications = showAll ? notif : notif.slice(0, 3);

    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] min-h-[50vh] md:h-full lg:h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
        <div className="text-center text-3xl md:text-4xl font-bold mb-4 md:mb-6">
          <p>Notifications</p>
        </div>

        {isNotifsLoading && (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
          </div>
        )}

        <div className="text-start justify-center w-full  items-center flex flex-col gap-3 md:gap-4 leading-relaxed md:leading-loose">
          {displayedNotifications?.map((item) => (
            <div
              key={item.id}
              className="relative w-full bg-white py-3 md:py-5 px-3 md:px-4 cursor-pointer rounded-2xl flex gap-2"
              onClick={() => {
                navigate("/membership/show-notification", {
                  state: {
                    notifId: item?.id,
                    memberId: member?.id,
                  },
                });
              }}
            >
              <div className="mt-1 md:mt-2 w-full grid grid-cols-[10%,90%] lg:items-center px-4 pt-2 gap-2 md:gap-4">
                <div className="w-fit">
                  <img
                    width={50}
                    className="md:w-[70px] justify-self-center"
                    src={imagess}
                    alt=""
                  />
                </div>
                <div className="flex text-start flex-col">
                  <div className="font-semibold text-sm md:text-base ">
                    {item.title}
                  </div>
                  <div className="text-xs md:text-sm line-clamp-2 font-light">
                    {item.message}
                  </div>
                </div>
              </div>

              <div className="absolute top-1 md:top-2 right-2 md:right-3 mb-5 flex self-start items-center">
                <div className="text-xs md:text-sm ">
                  {item.created_at.split("T")[0]}
                </div>
                {item.opened == 0 ? (
                  <div className="w-2 h-2 bg-[#e72a2ae7] rounded-full m-1"></div>
                ) : (
                  <div className=""></div>
                )}

                {/* <TbPointFilled
                        color="#0d70a1"
                        size={14}
                        className="md:size-[16px]"
                      /> */}
              </div>
            </div>
          ))}
          {!isNotifsLoading && (
            <div
              onClick={() => setShowAll(!showAll)}
              className="flex cursor-pointer flex-col gap-1 md:gap-2 justify-center items-center mt-3 md:mt-5"
            >
              {!showAll && notif.length > 3 ? (
                <IoIosArrowDown size={30} className="md:size-[50px]" />
              ) : (
                <IoIosArrowUp size={30} className="md:size-[50px]" />
              )}

              <div className="text-[#0D70A1] text-xl font-bold">
                {!showAll && notif.length > 3
                  ? `${t("twichiyat.show")}`
                  : `${t("twichiyat.hide")}`}
              </div>
            </div>
          )}
        </div>
      </div>
    );

    // return (
    //   <div
    //     className="flex flex-col gap-12 min-h-screen"
    //     style={{
    //       backgroundImage: `url(${images.golf_field})`,
    //       backgroundPosition: "center",
    //       backgroundSize: "cover",
    //       backgroundRepeat: "no-repeat",
    //       backgroundAttachment: "fixed",
    //     }}
    //   >
    //     <Nav />
    //     <div className="flex justify-center mx-16 mb-20">
    //       <div className="flex w-full justify-between items-start">
    //         <Sidebar />
    //         <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-16 gap-8 w-[75%] rounded-3xl py-12">
    //           <div className="text-center text-4xl font-bold mb-6">
    //             <p>Notifications</p>
    //           </div>
    //           {(() => {
    //             if (isNotifsLoading) {
    //               return (
    //                 <div className="flex justify-center items-center">
    //                   <div className="spinner"></div>
    //                 </div>
    //               );
    //             } else {
    //               console.log(
    //                 `notifications value after isNotfis loading become false == ${notif}`
    //               );
    //             }
    //           })()}
    //           <div className="text-start justify-center w-[70%] items-center flex flex-col gap-4 leading-loose">
    //             {displayedNotifications?.map((item) => (
    //               <div
    //                 key={item.id}
    //                 className="relative w-full bg-white py-5 px-4 cursor-pointer rounded-2xl flex gap-2 "
    //                 onClick={() => {

    //                   navigate("/membership/show-notification", {
    //                     state: {
    //                       notifId: item?.id,
    //                       memberId: member?.id,
    //                     },
    //                   });
    //                 }}

    //               >
    //                 <div className="mt-2 flex gap-4">
    //                   <div>
    //                     <img width={70} src={imagess} alt="" />
    //                   </div>
    //                   <div className="flex flex-col">
    //                     <div className="font-semibold">{item.title}</div>
    //                     <div className="text-sm font-light">{item.message}</div>
    //                   </div>
    //                 </div>

    //                 <div className="absolute top-2 right-3 flex self-start items-center">
    //                   <div>{item.created_at.split('T')[0]}</div>
    //                   <TbPointFilled color="#0d70a1" />
    //                 </div>
    //               </div>
    //             ))}

    //             { (
    //               <div
    //               onClick={() => setShowAll(!showAll)}
    //               className="flex cursor-pointer flex-col gap-2 justify-center items-center mt-5">

    //                 {!showAll && notif.length > 3 ? <IoIosArrowDown size={50} /> : <IoIosArrowUp size={50} />}

    //                 <div className="text-[#0D70A1] text-xl font-bold">
    //                   {!showAll && notif.length > 3 ? "Go to historical notifications": "Minimize"}

    //                 </div>
    //               </div>
    //             )}

    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //   </div>
    // );
  }
}
